// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1OhUP","inner":"Form_inner__1YIV0","range":"Form_range__A4_HD","name":"Form_name__mMdp9","actions":"Form_actions__1lkRp"};